import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  ru: {
    translation: {
      "username": "Логин",
      "password": "Пароль",
      "confirm_password": "Повторите пароль",
      "email": "Почта",
      "first": "Имя",
      "last": "Фамилия",
      "phone": "Телефон",
      "subject": "Тема",
      "full_name": "Ф.И.О.",
      "message": "Сообщение",
    }
  },
  uz: {
    translation: {
      "Смотреть онлайн": "Onlayn ko'rish",
      "Пользовательская соглашения": "Foydalanish bitimi",
      "Фильмы": "Filmlar",
      "Онлайн ТВ": "Onlayn TV",
      "Клипы": "Kliplar",
      "Обратная связь": "Qayta aloqa",
      "Отправить": "Jo'natish",
      "Музыка": "Tarona",
      "Обои": "Rasmlar",
      "Новости": "Yangiliklar",
      "Футбол": "Futbol",
      "Сериалы": "Seriallar",
      "Трейлеры": "Treylerlar",
      "Альбомы": "Albomlar",
      "Концерты": "Konsertlar",
      "Фестивали": "Festivallar",
      "Испольнители": "Ijrochilar",
      "Войти": "Kirish",
      "Выйти": "Chiqish",
      "Мой профиль": "Mening profilim",
      "Последние": "Yangilari",
      "Популярные": "Mashhurlari",
      "Любимые": "Yoqqanlari",
      "Показать все": "Hammasi ko'rish",
      "Для добавления видео в список любимых Вам необходимо авторизоваться.": "Videoni yoqqanlar ro'yxatiga qo'shish uchun ro'yxatdan o'ting.",
      "Ничего не найдено": "Hech narsa topilmadi",
      "Нет комментариев" : "Sharhlar yo'q",
      "Ответить": "Javob berish",
      "Опубликовать как" : "Quyidagi nom bilan jo'natish:",
      "Опубликовать" : "Jo'natish",
      "Поделиться своими мыслями..." : "O'z fikringizni baham ko'ring...",
      "Только зарегистрированные пользователи могут оставлять комментарии.": "Faqat ro'yxatdan o'tgan foydalanuvchilar sharh qoldirishlari mumkin.",
      "Ваш коммент отправлен на модерацию." : "Sizning sharhining tekshirishga yuborildi.",
      "Добавлен в избранные" :"Yoqqanlarga qo'shildi",
      "Удален из избранных": "Yoqqanlardan o'chirildi",
      "Для добавления в список любимых Вам необходимо авторизоваться." : "Yoqqanlar ro'yxatiga qo'shish uchun ro'yxatdan o'ting.",
      "Голос принят. Спасибо!": "Ovozingiz qabul qilindi. Rahmat!",
      "Голос изменен. Спасибо!": "Ovozingiz o'zgartirildi. Rahmat!",
      "Вы уже голосовали!": "Siz ovoz berib bo'ldingiz.",
      "Все жарны" : "Hamma janrlar",
      "Все страны": "Hamma davlatlar",
      "Все годы" :"Hamma yillar",
      "Новые": "Yangilari",
      "Просмотров": "Ko'rilgan",
      "Режиссер" :"Rejisyor",
      "В ролях" : "Rollarda",
      "открыть" : "ochish",
      "порядок" : "tartib",
      "повтор всех": "hammasini takrorlash",
      "повтор одного" :"bittasini takrorlash",
      "случайно" : "tasidifiy",
      "закрыть" : "yopish",
      "Список" : "Ro'yxat",
      "Пусто" : "Bo'sh",
      "Мои избранные" : "Mening yoqtirganlarim",
      "Авторизуйтесь." :"Ro'yxatdan o'tish",
      "Пожалуйста, авторизуйтесь" : "Iltimos, ro'yxatdan o'ting",
      "Регистрация" : "Ro'yxatdan o'tish",
      "Все комментарии" : "Hamma sharhlar",
      "Логин" : "Kirish",
      "Чат" : "Chat",
      "Видео и аудио записи предназначены исключительно для предварительного ознакомительного просмотра (прослушивания). Все права на исходные видеоматериалы принадлежат соответствующим организациям..." : "Video yozuvlar faqat oldindan ko'rish (tinglash) uchun mo'ljallangan. Videoning barcha huquqlari o'zlarining tashkilotlariga tegishli...",
      "Введите не менее 2 символов для поиска" : "Qidirish uchun 2tadan ko'p simvol yozish kerak",
      "Фильмы, сериалы, актеры..." : "Filmlar, seriallar, aktyorlar...",
      "Треки" : "Taronalar",
      "Фильтр" : "Filtr",
      "Все": "Hammasi",
      "Узбекские" : "O'zbekcha",
      "Русские" : "Ruscha",
      "Зарубежные" : "Boshqalar",
      "Популярные альбомы" : "Mashhur albomlar",
      "День": "Bugun",
      "Неделя" : "Xafta",
      "Месяц" : "Oy",
      "Показать меньше" : "Kamroq",
      "Показать больше" : "Ko'proq",
      "Испольнитель" : "Ijrochi",
      "Альбом" : "Albom",
      "Жанр" : "Janr",
      "Год выпуска": "Chiqarilgan yil",
      "Архив": "Arxiv",
      "Скачать": "Yuklab olish",
      "Жанры": "Janrlar",
      "Правообладателям" : "Mualliflik huquqi egalariga",
      "Популярные концерты": "Mashhur konsertlar",
      "Есть возрастное ограничение к этому видео. Вам уже больше 18 ?": "Yosh bo'yicha chegara mavjud. Sizning yoshingiz 18dan yuqorimi?",
      "Также рекомендуется" : "Maslahat beriladi",
      "Голосование разрешено только авторизованным пользователям.": "Ovoz berish faqat ro'yxatdan o'tgan foydalanuvchilarga ruxsat berilgan.",
      "Загрузки": "Yuklangan",
      "Просмотры": "Ko'rilganlar",
      "Популярные фестивали": "Mashhur festivallar",
      "Популярные матчи": "Mashhur o'yinlar",
      "У вас нету аккаунта?": "Ro'yxatdan o'tmaganmisiz?",
      "Войти через": "Orqali kirish",
      "Вход": "Kirish",
      "Запомни меня": "Meni yodda saqla",
      "Почта *": "Pochta *",
      "Пароль *": "Parol *",
      "Необходимо заполнить": "To'ldirish shart",
      "username": "Login",
      "password": "Parol",
      "confirm_password": "Parolni takrorlash",
      "email": "Pochta",
      "phone": "Telefon",
      "full_name": "F.I.Sh.",
      "subject": "Mavzu",
      "message": "Xat",
      "first": "Ism",
      "last": "Familiya",
      "Забыли пароль?": "Parolni unutdingizmi?",
      "Популярные треки": "Mashhur taronalar",
      "Сайт разработан": "Sayt ishlab chiqilgan",
      "Все жанры": "Hamma janrlar",
      "Страница не найдена": "Sahifa topilmadi",
      "Профиль": "Profil",
      "Данные сохранены": "Ma'lumotlar saqlandi",
      "Имя *": "Ism *",
      "Фамилия *": "Familiya *",
      "Логин *": "Login *",
      "Новый пароль (если хотите изменить)": "Yangi parol (agar o'zgartirmoqchi bo'lsangiz)",
      "Повторите новый пароль (если изменяете)": "Parolni takrorlang (agar o'zgartirayotgan bo'lsangiz)",
      "Сохранить": "Saqlash",
      "Пароли не совпадают": "Parollar bir xil emas",
      "Мужщина": "Erkak",
      "Женщина": "Ayol",
      "О проекте": "Loyiha haqida",
      "Реклама на сайте": "Saytda reklama",
      "У вас есть аккаунт?": "Ro'yxatdan o'tganmisiz?",
      "Повторите пароль *": "Parolni takrorlang *",
      "Условия и правила": "Shart va qoidalar",
      "Я согласен с": "Quyidagiga roziman",
      "Нужно согласиться": "Rozi bo'lish kerak",
      "Подтвердите капчу": "Kaptchani tasdiqlang",
      "Популярные клипы": "Mashhur kliplar",
      "Возраст": "Yosh",
      "Страна": "Davlat",
      "Качество": "Sifat",
      "Перевод": "Tarjima",
      "Подробнее": "Batafsil",
      "Сюжет": "Syujet",
      "Кадры из фильма": "Filmdan kadrlar",
      "Закрыть": "Yopish",
      "Смотреть": "Ko'rish",
      "Свернуть": "Qisqa qilish",
      "Быстрые ссылки": "Tezkor havolalar",
      "Новые треки" : "Yangi taronalar",
      "Поиск" : "Qidiruv",
      "ключевое слово" : "kalit so'z",
      "Концерты и фестивалы" : "Konsertlar va festivallar",
      "Телефон" : "Telefon",
      "Ф.И.О.": "F.I.Sh.",
      "Почта": "Pochta",
      "Тема": "Mavzu",
      "Как актёр": "Aktyor sifatida",
      "Как режиссер": "Rejissor sifatida",
      "Актёр в": "Aktyor sifatida",
      "фильмах": "filmlarda",
      "фильмов": "filmlarda",
      "Режиссер ": "Rejissor sifatida ",
      "Все каналы": "Hamma kanallar",
      "Другие каналы": "Boshqa kanallar",
      "ТВ": "TV",
      "Сообщение": "Xat"
    }
  }
};

let language = localStorage.getItem("language");

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: language ? language : "ru",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;